import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: 0,
    marginBottom: 0,
  },
  sub: {
    color: "#000",
    fontSize: 10,
    textAlign: "left",
  },
  billTo: {
    color: "#000",
    fontSize: 10,
    textAlign: "left",
    marginTop: 10,
    marginBottom: 5,
    lineHeight: 1.5,
  },
  billToMain: {
    color: "#000",
    fontSize: 10,
    textAlign: "left",
    marginTop: 0,
    marginBottom: 0,
    lineHeight: 1.5,
  },
});

const Subject = ({ invoice }) => (
  <View style={styles.headerContainer}>
    <Text style={styles.sub}><b>Sub: Quotation for your travel Itinerary</b></Text>
    <Text style={styles.billTo}>
      {" "}
      Dear Sir/Madam, 
   
      </Text>
      <Text style={styles.billToMain}>
      Please find below the details of the prices for the travel items as per
      your requirements.{" "}
    </Text>
  </View>
);

export default Subject;
